import gql from 'graphql-tag';
import PaymentMethodFragment from '../fragments/PaymentMethodFragment';

export default gql`
query AdminPaymentMethodsList {
    adminPaymentMethods {
        ...PaymentMethodFragment
    }
}
${PaymentMethodFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminPaymentMethods.ts